import React, { useEffect, useRef } from "react";
import { selectDeviceVariant } from "./adVariant";

export default function BlurReload({ isDesktop, domain, refresh, sid, timeout }) {
    const timeoutIdRef = useRef(null);
    // selectDeviceVariant пропускает скаляр насквозь: старые кампании хранят
    // refresh строкой, новые — словарём pc/mob, из БД приходит готовый slug.
    const refreshLink = selectDeviceVariant(refresh, isDesktop);

    useEffect(() => {
        if (!timeout || !refreshLink) {
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const blur = params.get("blur");

        if (blur != null) {
            return;
        }

        const redirect = () => {
            window.location.href = `https://${domain}/pages/${refreshLink}/?subid=${sid}`;
        };

        const onBlur = () => {
            timeoutIdRef.current = setTimeout(redirect, `${timeout}000`);
        };

        const onFocus = () => {
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
                timeoutIdRef.current = null;
            }
        };

        window.onblur = onBlur;
        window.onfocus = onFocus;

        return () => {
            window.onblur = null;
            window.onfocus = null;
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
            }
        };
    }, [isDesktop, domain, refreshLink, timeout, sid]);

    return null;
}
